import { render, staticRenderFns } from "./gTranslate.vue?vue&type=template&id=f1710d8e&scoped=true&"
import script from "./gTranslate.vue?vue&type=script&lang=js&"
export * from "./gTranslate.vue?vue&type=script&lang=js&"
import style0 from "./gTranslate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./gTranslate.vue?vue&type=style&index=1&id=f1710d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1710d8e",
  null
  
)

export default component.exports